module.exports = __webpack_public_path__ + "static/img/edit.92861e27.svg";